import * as actions from "store/actions/bankBillet";
import IUser from "Types/BankBillet";

export interface BankBilletState {
	items: IUser[];
	filter: any[];
	pages: any;
	count: number;
	loading: any;
	errors: any;
}

interface MyAction {
	type: string;
	payload: any;
}

const initialState: BankBilletState = {
	items: [],
	filter: [],
	pages: null,
	count: 0,
	loading: { getAll: false, import: false },
	errors: {}
};

const reducer = function (state = initialState, action: MyAction) {
	const { type, payload } = action;
	switch (type) {
		case actions.GET_MEIS: {
			return {
				...state,
				loading: { getAll: true },
				errors: initialState.errors
			};
		}
		case actions.GET_MEIS_SUCCESS: {
			return {
				...state,
				items: payload || [],
				loading: { getAll: false }
			};
		}
		case actions.GET_MEIS_FAILED: {
			return {
				...state,
				loading: { getAll: false },
				errors: payload
			};
		}
		case actions.IMPORT_MEIS: {
			return {
				...state,
				loading: { import: true },
				errors: initialState.errors
			};
		}
		case actions.IMPORT_MEIS_SUCCESS: {
			return {
				...state,
				loading: { import: false }
			};
		}
		case actions.IMPORT_MEIS_FAILED: {
			return {
				...state,
				loading: { import: false },
				errors: payload
			};
		}
		case actions.SET_VALUE:
			return {
				...state,
				...payload
			};
		case actions.CLEAR_VALUES:
			return {
				...initialState
			};
		default: {
			return state;
		}
	}
};

export default reducer;
